import type * as UpdateOrganizationContactAPI from 'ab-api/web/organizationContact/updateOrganizationContact';

import { isValidEmail } from '@acceligentllc/shared/utils/email';

export class OrganizationContactFM {
	email: string;

	static validate(form: OrganizationContactFM) {
		const errors: ValidationErrors = {};

		if (!isValidEmail(form.email)) {
			errors.email = 'Email invalid';
		}

		return errors;
	}

	static toUpdateRM(
		form: OrganizationContactFM
	): UpdateOrganizationContactAPI.W_OrganizationContact_UpdateOrganizationContact_RM {
		return {
			...form,
		};
	}
}
